export default __webpack_public_path__ + "static/counterfeit_equipment_upgrade-56a9be916eff4029c91c65812abfc7ec.png";